// Custom Recently Viewed functionality using localStorage

// Initialize recently viewed on page load
document.addEventListener('DOMContentLoaded', function() {
  initializeRecentlyViewed();
});

function initializeRecentlyViewed() {
  // Auto-track product view if we're on a product page
  if (window.location.pathname.includes('/products/')) {
    trackProductView();
  }
}

function trackProductView() {
  // Get product data from the page
  const productData = getProductDataFromPage();
  
  if (productData && productData.id) {
    addToRecentlyViewed(productData);
  }
}

function getProductDataFromPage() {
  // Try to get product data from various sources on the page
  let productData = null;
  
  // Method 1: Check for product JSON in script tags
  const productScripts = document.querySelectorAll('script[type="application/json"]');
  for (let script of productScripts) {
    try {
      const data = JSON.parse(script.textContent);
      if (data.id && data.title) {
        productData = {
          id: data.id.toString(),
          handle: data.handle,
          title: data.title,
          url: window.location.pathname,
          image: data.featured_image || (data.images && data.images[0]),
          price: data.price ? (data.price / 100).toFixed(2) : '0.00',
          comparePrice: data.compare_at_price ? (data.compare_at_price / 100).toFixed(2) : null,
          available: data.available
        };
        break;
      }
    } catch (e) {
      // Continue to next script
    }
  }
  
  // Method 2: Check for global product variable
  if (!productData && typeof window.product !== 'undefined') {
    const product = window.product;
    productData = {
      id: product.id.toString(),
      handle: product.handle,
      title: product.title,
      url: window.location.pathname,
      image: product.featured_image || (product.images && product.images[0]),
      price: product.price ? (product.price / 100).toFixed(2) : '0.00',
      comparePrice: product.compare_at_price ? (product.compare_at_price / 100).toFixed(2) : null,
      available: product.available
    };
  }
  
  // Method 3: Extract from meta tags and page elements
  if (!productData) {
    const productId = document.querySelector('meta[property="product:id"]')?.content ||
                     document.querySelector('[data-product-id]')?.dataset.productId;
    const productTitle = document.querySelector('h1')?.textContent?.trim() ||
                        document.querySelector('.product-title')?.textContent?.trim() ||
                        document.title;
    const productImage = document.querySelector('.product-image img')?.src ||
                        document.querySelector('.featured-image img')?.src ||
                        document.querySelector('meta[property="og:image"]')?.content;
    const priceElement = document.querySelector('.price')?.textContent ||
                        document.querySelector('[data-price]')?.dataset.price;
    
    if (productId && productTitle) {
      productData = {
        id: productId.toString(),
        handle: window.location.pathname.split('/').pop(),
        title: productTitle,
        url: window.location.pathname,
        image: productImage,
        price: priceElement ? parseFloat(priceElement.replace(/[^0-9.]/g, '')).toFixed(2) : '0.00',
        comparePrice: null,
        available: true
      };
    }
  }
  
  return productData;
}

function addToRecentlyViewed(productData) {
  // Get existing data (handles only from the existing system)
  let recentlyViewedHandles = getRecentlyViewedFromStorage();
  
  // Remove if already exists to avoid duplicates
  recentlyViewedHandles = recentlyViewedHandles.filter(handle => handle !== productData.handle);
  
  // Add to beginning of array
  recentlyViewedHandles.unshift(productData.handle);
  
  // Keep only last 8 items
  recentlyViewedHandles = recentlyViewedHandles.slice(0, 8);
  
  // Save handles for compatibility with existing system
  saveRecentlyViewedToStorage(recentlyViewedHandles);
  
  // Also save full product data for our custom display
  saveFullProductData(productData);
  
  updateRecentlyViewedCount();
  
  // Update recently viewed display if the function exists
  if (typeof displayRecentlyViewedItems === 'function') {
    displayRecentlyViewedItems();
  }
}

function getRecentlyViewedFromStorage() {
  try {
    // Use the same localStorage key as the existing system
    const storageKey = `recentlyViewedProduct-${window.theme.enviroment}`;
    const recentlyViewed = localStorage.getItem(storageKey);
    return recentlyViewed ? JSON.parse(recentlyViewed) : [];
  } catch (error) {
    console.error('Error reading recently viewed from localStorage:', error);
    return [];
  }
}

function saveRecentlyViewedToStorage(recentlyViewed) {
  try {
    // Use the same localStorage key as the existing system
    const storageKey = `recentlyViewedProduct-${window.theme.enviroment}`;
    localStorage.setItem(storageKey, JSON.stringify(recentlyViewed));
  } catch (error) {
    console.error('Error saving recently viewed to localStorage:', error);
  }
}

function saveFullProductData(productData) {
  try {
    // Save full product data separately for our custom display
    const storageKey = `customRecentlyViewedData-${window.theme.enviroment}`;
    let fullData = JSON.parse(localStorage.getItem(storageKey) || '{}');
    fullData[productData.handle] = productData;
    localStorage.setItem(storageKey, JSON.stringify(fullData));
  } catch (error) {
    console.error('Error saving full product data to localStorage:', error);
  }
}

function getFullProductData() {
  try {
    const storageKey = `customRecentlyViewedData-${window.theme.enviroment}`;
    return JSON.parse(localStorage.getItem(storageKey) || '{}');
  } catch (error) {
    console.error('Error reading full product data from localStorage:', error);
    return {};
  }
}

function getRecentlyViewedCount() {
  return getRecentlyViewedFromStorage().length;
}

function updateRecentlyViewedCount() {
  const count = getRecentlyViewedCount();
  const countElements = document.querySelectorAll('.recently-viewed-count');
  
  countElements.forEach(element => {
    element.textContent = count;
    element.style.display = count > 0 ? 'inline' : 'none';
  });
}

function clearRecentlyViewed() {
  // Clear both storage locations
  const handleStorageKey = `recentlyViewedProduct-${window.theme.enviroment}`;
  const dataStorageKey = `customRecentlyViewedData-${window.theme.enviroment}`;
  
  localStorage.removeItem(handleStorageKey);
  localStorage.removeItem(dataStorageKey);
  
  updateRecentlyViewedCount();
  showNotification('Recently viewed cleared', 'removed');
  
  // Update recently viewed display if the function exists
  if (typeof displayRecentlyViewedItems === 'function') {
    displayRecentlyViewedItems();
  }
}

function showNotification(message, type = 'info') {
  // Create notification element
  const notification = document.createElement('div');
  notification.className = `recently-viewed-notification fixed top-4 right-4 z-50 px-4 py-2 rounded-md shadow-lg transition-all duration-300 transform translate-x-full`;
  
  // Set notification style based on type
  if (type === 'removed') {
    notification.style.backgroundColor = '#ef4444';
    notification.style.color = 'white';
  } else {
    notification.style.backgroundColor = '#10b981';
    notification.style.color = 'white';
  }
  
  notification.textContent = message;
  document.body.appendChild(notification);
  
  // Animate in
  setTimeout(() => {
    notification.style.transform = 'translateX(0)';
  }, 100);
  
  // Animate out and remove
  setTimeout(() => {
    notification.style.transform = 'translateX(full)';
    setTimeout(() => {
      if (notification.parentNode) {
        notification.parentNode.removeChild(notification);
      }
    }, 300);
  }, 3000);
}

// Function to get full recently viewed products for display
function getRecentlyViewedProducts() {
  const handles = getRecentlyViewedFromStorage();
  const fullData = getFullProductData();
  
  // Return full product objects in the correct order
  return handles.map(handle => fullData[handle]).filter(Boolean);
}

// Export functions for use in other scripts
window.customRecentlyViewed = {
  track: trackProductView,
  add: addToRecentlyViewed,
  get: getRecentlyViewedProducts,
  getHandles: getRecentlyViewedFromStorage,
  clear: clearRecentlyViewed,
  count: getRecentlyViewedCount,
  updateCount: updateRecentlyViewedCount,
  showNotification: showNotification
};

// Auto-track product views on navigation (for SPAs)
let lastUrl = location.href;
new MutationObserver(() => {
  const url = location.href;
  if (url !== lastUrl) {
    lastUrl = url;
    if (url.includes('/products/')) {
      setTimeout(trackProductView, 500); // Small delay to ensure page is loaded
    }
  }
}).observe(document, { subtree: true, childList: true });